export default {
  flock_app_store: 'Flock App Store',
  get_more_apps: 'Consigue m\u00e1s aplicaciones',
  app_store_button_label: 'Aplicaciones',
  directory_button_label: 'Directorio',
  roster_title: 'Canales y contactos',
};
